import { render, staticRenderFns } from "./StockMomentumList.vue?vue&type=template&id=5bb13c8a&scoped=true"
import script from "./StockMomentumList.vue?vue&type=script&lang=js"
export * from "./StockMomentumList.vue?vue&type=script&lang=js"
import style0 from "./StockMomentumList.vue?vue&type=style&index=0&id=5bb13c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb13c8a",
  null
  
)

export default component.exports